import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Toolbar, Typography } from './../../../../../themes/default';

const styles = theme => ({
  root: {
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    borderBottom: `5px solid ${ theme.palette.grey[200] }`
  },
  title: {
    flex: '0 0 auto'
  },
  element: {
    color: theme.palette.grey[500],
    fontSize: theme.spacing.unit * 2.2,
    fontWeight: theme.typography.fontWeightRegular
  },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  }
});

const Ttolbar = ({ children, title, subtitle, ...rest}) => {

  const { classes } = rest;

  return(
    <Toolbar className={ classes.root }>
      <div className={ classes.title }>
        <Typography variant="h6" component="h3" className={ classes.element }>
          { title }
          {
            subtitle && (
              <Typography component="span">{ subtitle }</Typography>
            )
          }
        </Typography>
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        { children }
      </div>
    </Toolbar>
  )

}

Ttolbar.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node
};

export default withStyles(styles)(Ttolbar);
